import { toLiveDomainId } from "./membership.js";
import { findTerm, getWordIndex, normalizeDictionaryName } from "./dictionaryIndex.js";
//#region src/engine/modules/dictionary/derive.ts
var WordTokenKind = {
	word: "word",
	synonym: "synonym",
	forbidden: "forbidden",
	unregistered: "unregistered"
};
var SEPARATORS = /[\s_\-·/]+/u;
var splitNameUnits = (logicalName) => normalizeDictionaryName(logicalName).split(SEPARATORS).filter((unit) => unit !== "");
var hasMarks = (marks) => marks.words.length > 0 || marks.synonymOf.length > 0 || marks.forbiddenOf.length > 0;
function longestMatch(root, unit, start) {
	let node = root;
	let found = null;
	for (let index = start; index < unit.length; index++) {
		node = node.next.get(unit.charCodeAt(index));
		if (!node) break;
		if (node.marks && hasMarks(node.marks)) found = {
			end: index + 1,
			marks: node.marks
		};
	}
	return found;
}
function toToken(text, marks) {
	if (marks.words.length) return {
		text,
		kind: WordTokenKind.word,
		words: marks.words
	};
	if (marks.forbiddenOf.length) return {
		text,
		kind: WordTokenKind.forbidden,
		words: marks.forbiddenOf
	};
	return {
		text,
		kind: WordTokenKind.synonym,
		words: marks.synonymOf
	};
}
var unregistered = (text) => ({
	text,
	kind: WordTokenKind.unregistered,
	words: []
});
function decompose(index, logicalName) {
	const tokens = [];
	for (const unit of splitNameUnits(logicalName)) {
		let pending = 0;
		let position = 0;
		while (position < unit.length) {
			const match = longestMatch(index.root, unit, position);
			if (!match) {
				position++;
				continue;
			}
			if (pending < position) tokens.push(unregistered(unit.slice(pending, position)));
			tokens.push(toToken(unit.slice(position, match.end), match.marks));
			position = match.end;
			pending = position;
		}
		if (pending < unit.length) tokens.push(unregistered(unit.slice(pending)));
	}
	return tokens;
}
function compose(tokens) {
	if (tokens.length === 0) return null;
	const abbreviations = [];
	for (const token of tokens) {
		if (token.kind !== WordTokenKind.word) return null;
		const abbreviation = token.words[0]?.abbreviation.trim() ?? "";
		if (!abbreviation) return null;
		abbreviations.push(abbreviation);
	}
	return abbreviations.join("_");
}
function composeName(state, logicalName) {
	const index = getWordIndex(state);
	if (index.byName.size === 0) return null;
	return compose(decompose(index, logicalName));
}
function derivePhysical(state, logicalName) {
	const name = normalizeDictionaryName(logicalName);
	if (!name) return null;
	const term = findTerm(state, name);
	if (term) return {
		physicalName: term.physicalName.trim() || (composeName(state, name) ?? ""),
		domainId: toLiveDomainId(state, term.domainId),
		term
	};
	const physicalName = composeName(state, name);
	return physicalName ? {
		physicalName,
		domainId: "",
		term: null
	} : null;
}
//#endregion
export { WordTokenKind, compose, composeName, decompose, derivePhysical, splitNameUnits };
